((app, ng) => {
    //
    // Md-dialog's "this" refers to the window instead of the an
    // isolated scope. So we'll set $ctrl to an empty object instead 
    // to keep the template naming convention intact.
    //
    app.controller("frequencyCtrl", ["$scope", "$mdDialog", "$q", "processorTrackApi", "track", 
        ($scope, $mdDialog, $q, processorTrackApi, track) => {
            let $ctrl = {};
            $scope.$ctrl = $ctrl;
            $ctrl.track = ng.copy(track);
            $ctrl.ui = { saving: false };

            $ctrl.$onInit = async () => {
                try {
                    $ctrl.frequencyTypes = await processorTrackApi.getFrequencyTypes();
                } catch(err) {
                    // toast
                    console.error(err);
                }
            };
            $ctrl.$onInit();

            $ctrl.close = (updates) => {
                $mdDialog.hide(updates);
            };

            $ctrl.updateFrequency = () => {
                $ctrl.ui.saving = true;
                let promises = [];
                promises.push(processorTrackApi.updateFrequency($ctrl.track));
                $q.all(promises)
                    .finally(() => {
                        $ctrl.ui.saving = false;
                        $ctrl.close(true);
                    });
            };
        }]);
})(window.app, window.angular);